import Styles from './styles.module.css';
import React from 'react'
import { createPortal } from 'react-dom';
import { TAG_CATEGORIES, MAX_TAGS } from '../../tagConstants';

type StyleTagsProps = {
  style: string[];
  setStyle: React.Dispatch<React.SetStateAction<string[]>>;
  setSwitchStyle: React.Dispatch<React.SetStateAction<boolean>>;
};

const StyleTags: React.FC<StyleTagsProps> = ({ style, setStyle, setSwitchStyle }) => {

  function pushStyle(value: string) {
    if (style.length <= MAX_TAGS - 1) {
      setStyle([...style, value])
    }
  }

  // 画像アップロードダイアログ(1.post/index.tsx)の中からこの画面を開くと、
  // 親側がWindows用に position:fixed の containing block を書き換える
  // transform(scale)を掛けているため、この画面自身が同じ流儀で
  // zoom/transform補正をしても親のtransformの影響下から逃れられず、
  // 画面外に大きくズレて表示されてしまっていた。document.bodyへ
  // portalすることでDOM上は常にルート直下になり、祖先のzoom/transformに
  // 一切影響されなくなる(=補正自体が不要になる)。
  return createPortal(
    <>
    <div className={Styles.modal}>
      <div>
        <div className={Styles.modal_black} onClick={() => setSwitchStyle(false)}></div>
        <div className={Styles.modal_contents}>

          <div className={Styles.title}>
            <h5>その他のタグ</h5>
            <div>
              <button onClick={() => setStyle([])}>クリア</button>
              <button onClick={() => setSwitchStyle(false)}>確定</button>
            </div>
          </div>

          <p className={Styles.desc}>
            {style.length <= MAX_TAGS - 1 ? `※${MAX_TAGS}つ以上のタグを選択する事は出来ません。` : <span>{`※${MAX_TAGS}つ以上のタグを選択する事は出来ません。`}</span> }
          </p>

          <div className={Styles.select}>
            {TAG_CATEGORIES.map((category) => (
              <React.Fragment key={category.label}>
                <h5>{category.label}</h5>
                <div>
                  {category.values.map((data, index) =>
                    <div key={index}>
                      <input type="checkbox" checked={style.indexOf(data) !== -1}
                        onChange={(e) => e.target.checked ? pushStyle(data) : setStyle(style.filter((v) => (v !== data)))}/>
                      <p>{data}</p>
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>,
    document.body
  );
}

export default StyleTags;
